/* eslint-disable react-hooks/exhaustive-deps */
import  { useEffect } from 'react';
import {  Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCircleXmark, faMagnifyingGlass, faSort, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { useState } from 'react';
import { getUserListRequest } from '../../../redux/modules/settings/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import useAxios from '../../../hooks/useAxios';
import { API_ENDPOINTS } from '../../../constants/api';
import { toaster } from '../../../utils/toast';
import { toast } from 'react-toastify';
import XDeleteModal from '../../../component/modal/XDeleteModal';
import XButton from '../../../component/button/XButton';
import { useNavigate } from 'react-router-dom';
import { debounce } from '../../../utils/helper';
import useSidebar from '../../../hooks/useSidebar';
import PaginationNav from '../../../component/pagination/pagination';
import XLoader from '../../../component/loader/XLoader';
import { ROLE } from '../../../utils/enums';

const ROLE_DISPLAY_NAMES: Record<number, string> = {
  [ROLE.ORG_STAFF]: 'User',
  [ROLE.SUPER_ADMIN]: 'Super Admin',
  [ROLE.ORG]: 'Organisation',
  [ROLE.SUPER_ADMIN_STAFF]: 'Super Admin Staff',
  [ROLE.READ_ONLY]: 'Read Only',
  [ROLE.ACCOUNT_ADMIN]: 'Account Admin',
  [ROLE.LOCATION_ADMIN]: 'Location Admin',
  [ROLE.LOCATION_STAFF]: 'Location Staff',
};

const formatRoleName = (roleId?: number, roleName?: string): string => {
  if (roleId && ROLE_DISPLAY_NAMES[roleId]) {
    return ROLE_DISPLAY_NAMES[roleId];
  }
  if (roleName) {
    return roleName
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
  const enumKey = Object.keys(ROLE).find((key) => ROLE[key as keyof typeof ROLE] === roleId);
  if (enumKey) {
    return enumKey
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  return '-';
};

interface User {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role_id?: number;
  role_name?: string;
  location_name?: string;
  can_email_send?: boolean;
}
const Users = () => {
  const dispatch = useDispatch();
  const {userlist,loading} = useSelector((state: RootState) => state.settings);
  const { selectedLocationId } = useSelector((state: RootState) => state.user);
  const { deleteData, postData } = useAxios();
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [updatingUserId, setUpdatingUserId] = useState<string | null>(null);
  const [sendPermissions, setSendPermissions] = useState<Record<string, boolean>>({});
  const navigate = useNavigate()
  const [queryParams, setQueryParams] = useState({
    search: '',
    page: 1,
    limit: 10,
  });
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [totalPages, setTotalPages] = useState<number>(0);
  const { onShowSidebar } = useSidebar();
  useEffect(() => {
    dispatch(getUserListRequest({ ...queryParams, locationId: selectedLocationId }));
  }, [queryParams, selectedLocationId])
  useEffect(() => {
    const totalContacts = userlist?.totalCount;
    const totalPages = Math.ceil(totalContacts / queryParams?.limit);
    setTotalPages(totalPages);
  }, [userlist?.totalCount])

  useEffect(() => {
    if (userlist?.users) {
      const map: Record<string, boolean> = {};
      userlist.users.forEach((u: any) => {
        map[u.id] = !!u.can_email_send;
      });
      setSendPermissions(map);
    }
  }, [userlist?.users]);

  const handleToggleSendPermission = async (userId: string, newStatus: boolean) => {
    try {
      setUpdatingUserId(userId);
      setSendPermissions((prev) => ({ ...prev, [userId]: newStatus }));
      const response = await postData(API_ENDPOINTS.TOGGLE_USER_SEND_PERMISSION, {
        userId,
        send_permission: newStatus,
        locationId: selectedLocationId || null,
      });
      if (response && response.success) {
        toaster({ success: true, message: response.message || 'Send permission updated successfully' });
      } else {
        setSendPermissions((prev) => ({ ...prev, [userId]: !newStatus }));
        toaster({ success: false, message: response?.message || 'Failed to update send permission' });
      }
    } catch (error) {
      setSendPermissions((prev) => ({ ...prev, [userId]: !newStatus }));
      toaster({ success: false, message: 'Failed to update send permission' });
    } finally {
      setUpdatingUserId(null);
    }
  };

  const handlePageChange = (pageNumber: number) => {
    setQueryParams((prevParams) => ({ ...prevParams, page: pageNumber }));
  };
  const handleSearchChange = (searchValue: string): void => {
    setQueryParams((prevParams) => ({ ...prevParams, search: searchValue }));

  };

  const debouncedHandleSearchChange = debounce(handleSearchChange, 500);


const handleDeleteUser =async(id:string)=>{
  try {
  const response=await deleteData(`${API_ENDPOINTS.DELETE_USER}/${id}`);
  if (response && response.success === true) {
    toast(response.message);
    dispatch(getUserListRequest({ ...queryParams, locationId: selectedLocationId }));
  }
  } catch (error) {
    toaster({ success: false, message: "error fetching users" });
  }

}
const handleDeleteIconClick = (user:any) => {
  setSelectedUser(user);
  setShowDeleteModal(true);
};
  const addUserButtonHandler = ()=>{
    navigate('addUser')
  }
const handleEditClick=(id:any)=>{
  navigate(`addUser/${id}`)

}
const handleSortClick = (column: string) => {
  if (sortColumn === column) {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  } else {
    setSortColumn(column);
    setSortOrder('asc');
  }
};
const sortedUsers = [...(userlist?.users || [])].sort((a, b) => {
  if (sortColumn) {
    const aValue = a[sortColumn];
    const bValue = b[sortColumn];
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }
  }
  return 0;
});

  return (
    <div>
      <div className="main-title d-flex align-items-center justify-content-between main-title-block">
        <h2 className='d-flex align-items-center'>
          <span className="d-lg-none cursor-pointer" onClick={()=>onShowSidebar()}><FontAwesomeIcon icon={faBars} /></span>Users</h2>
        <div className="filter-bar d-flex align-items-center row-item top-block">
          <div className='position-relative search-bar'>
            <Form.Control
              type="search"
              placeholder="Search"
              aria-label="Search"
              // value={queryParams.search}
              onChange={(e) => debouncedHandleSearchChange(e.target.value)}
            />
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </div>
        <XButton buttonText='Add New User' className="btn-theme" onClick={addUserButtonHandler}/>
        </div>
        {/* <Button
            variant="primary"
            type="submit"
            className="btn-theme"
          >Add User
          </Button> */}
      </div>

      <div className="table-listing all-contacts users-list position-relative">
        <Table responsive>
          <thead>
            <tr>
              <th >First Name <FontAwesomeIcon icon={faSort} onClick={() => handleSortClick('first_name')}/></th>
              <th >Last Name <FontAwesomeIcon icon={faSort} onClick={() => handleSortClick('last_name')}/></th>
              <th>Email Address</th>
              <th>Role</th>
              <th>Location</th>
              <th>Can Send</th>
              <th>Status</th>
              <th>Actions </th>
            </tr>
          </thead>
          
          <tbody>
          {!loading && sortedUsers?.length === 0 &&
            <tr>
              <td colSpan={10}>
            <p className='text-center no-records'>No Users found.</p>
            </td>
            </tr>}

            {!loading && sortedUsers && sortedUsers?.map((user:any) => (
               <tr key={user.id}>
               <td>{user.first_name}</td>
               <td>{user.last_name}</td>
               <td>{user.email}</td>
               <td>{formatRoleName(user.role_id, user.role_name)}</td>
               <td>{user.location_name || '-'}</td>
               <td>
                 <Form.Check
                   type="switch"
                   id={`can-email-send-${user.id}`}
                   checked={sendPermissions[user.id] ?? !!user.can_email_send}
                   disabled={updatingUserId === user.id || user.role_id === ROLE.READ_ONLY}
                   onChange={(e) => handleToggleSendPermission(user.id, e.target.checked)}
                 />
               </td>
               <td>
                  {user?.is_active ? (
  <span className='text-green'>Activate</span>
  ) : (
    <span className='text-red'>Deactivate</span>
  )}
                 {/* <Modal show={show} onHide={handleClose} centered>
                   <Modal.Header closeButton>
                   </Modal.Header>
                   <Modal.Body>
                     <span className="content">
                       <p>Are you sure you want to activate this account?</p>
                     </span>
                   </Modal.Body>
                   <Modal.Footer className='justify-content-center'>
                     <Button variant="primary" type="submit" className='btn-theme btn-green' onClick={handleClose}>
                       Yes
                     </Button>
                     <Button variant="primary" className='btn-theme btn-red' >
                       No
                     </Button>
                   </Modal.Footer>
                 </Modal> */}
               </td>
               <td className='actions'>
                 <FontAwesomeIcon icon={faCircleXmark}  
                 onClick={() => handleDeleteIconClick(user)}
                 />
                 <FontAwesomeIcon icon={faPenToSquare} onClick={()=>handleEditClick(user?.id)} />
               </td>
             </tr> 
              ))}       
          </tbody>
        </Table>
        {loading && <XLoader />}
      </div>
          <XDeleteModal
            show={showDeleteModal}
            handleClose={() => setShowDeleteModal(false)}
            title="Delete User"
            body={`Are you sure you want to delete the user ${selectedUser?.first_name} ${selectedUser?.last_name}?`}
            onConfirm={() => {
              if (selectedUser) {
                handleDeleteUser(selectedUser.id);
              }    setShowDeleteModal(false);
            }}
          onCancel={() => setShowDeleteModal(false)} 
    />
      {!loading && sortedUsers?.length !== 0 && (
        <PaginationNav
          totalPages={totalPages}
          currentPage={queryParams.page}
          handlePageChange={handlePageChange}
        />
      )}
    </div>
  )
}

export default Users
